import { Button, Grid } from '@material-ui/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import React, { useRef } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { ResponsiveContainer } from 'recharts';
import * as XLSX from 'xlsx';
import ReportStyle from '../../reports/ClaimReport/Report.module.css';
import styles from '../../reports/ClaimReport/Table.module.css';
import CmsfLogo from '../../reports/ClaimReport/logo.png';
import { convertImageToBase64 } from '../../utils/strings/imageToBase64Convert';

const UiOfAttendanceReport = ({ data,stateValus,reportType,singleDateforAllType,tableData}) => {

  
  const params = useParams();
  const pdfRef = useRef();
  const pdfRef2 = useRef();

  const reportDate = new Date().toLocaleDateString(); // Get today's date
  const currentTime = new Date().toLocaleTimeString(); // Get current time
  const currentDateTime = `${reportDate} ${currentTime}`; // Combine Date and Time for footer



const generatePdfFile = () => {
  const doc = new jsPDF("portrait");

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

// 

// Convert Image and Generate PDF
  convertImageToBase64(CmsfLogo, (base64Image) => {
    const imgWidth = 40; // Set image width
    const imgHeight = 20; // Set image height
    const xPosition = (pageWidth - imgWidth) / 2; // Center horizontally
    const yPosition = 10;

      doc.addImage(base64Image, 'PNG', xPosition, 10, imgWidth, imgHeight); // Add Image

      // Add Center-Aligned Contact Info Below the Image
      const contactText = `Dhaka Chamber Building (3rd Floor), 65-66 Motijheel C/A, Dhaka-1000
  Tel: +880241052430, Email: claim@cmsfbd.org`;
  const reportTitle = `Attendance Report`
      
      const textY = yPosition + imgHeight + 10; // Position text below the image
      doc.setFontSize(10);
      doc.text(contactText, pageWidth / 2, textY, { align: 'center' });

      // Draw Underline Below the Contact Info
      const underlineY = textY + 5; // Adjust 5px below the text
      doc.setLineWidth(0.5);
      doc.line(10, underlineY, pageWidth - 10, underlineY); // Line from left to right margin

    // Add "Attendance Report" and Date Below the Line
    const reportTextY = underlineY + 10; // Position text below the line
    doc.setFontSize(12);
    doc.text(reportTitle, pageWidth / 2, reportTextY, { align: 'center' });

    const dateY = reportTextY + 6; // Position date below the title
    doc.setFontSize(10);
    doc.text(`From: ${stateValus.fromDate} To: ${stateValus.toDate}`, pageWidth / 2, dateY, { align: 'center' });



    const tableStartY = dateY + 10; // Starting position for the table
    const columnWidths = [8, 45, 45, 25, 30, 30, 30]; // Define column widths
    const columnTitles = ['Sl', 'Emp Id','Name', 'Designation', 'Date', 'Log In Time', 'Log Out Time', 'Remarks'];
    const rowHeight = 8;

    doc.setFontSize(8);
    columnTitles.forEach((title, index) => {
        doc.text(title, 10 + columnWidths.slice(0, index).reduce((acc, val) => acc + val, 0), tableStartY);
    });

    data.forEach((row, rowIndex) => {
      const rowY = tableStartY + (rowIndex + 1) * rowHeight;

      // Safely handle undefined values
      const sl = `${rowIndex + 1}`; // Check if 'sl' exists
      const empId = row.empidr || '';
      const name = row.emp_name || '';
      const designation = row.desig || '';
      const date = row.attdate || '';
      const loginTime = row.intime || '';
      const logoutTime = row.outtime || '';
      const remarks = row.remarks || '';

      doc.text(sl, 10, rowY);
      doc.text(empId, 10 + columnWidths[0], rowY);
      doc.text(name, 10 + columnWidths[0] + columnWidths[1], rowY);
      doc.text(designation, 10 + columnWidths[0] + columnWidths[1] + columnWidths[2], rowY);
      doc.text(date, 10 + columnWidths[0] + columnWidths[1] + columnWidths[2] + columnWidths[3], rowY);
      doc.text(loginTime, 10 + columnWidths[0] + columnWidths[1] + columnWidths[2] + columnWidths[3] + columnWidths[4], rowY);
      doc.text(logoutTime, 10 + columnWidths[0] + columnWidths[1] + columnWidths[2] + columnWidths[3] + columnWidths[4] + columnWidths[5], rowY);
      doc.text(remarks, 10 + columnWidths[0] + columnWidths[1] + columnWidths[2] + columnWidths[3] + columnWidths[4] + columnWidths[5] + columnWidths[6], rowY);
    });

   // Add Page Number and Today's Date-Time as Footer
   const pageNumber = doc.internal.getNumberOfPages();
   const footerY = doc.internal.pageSize.height - 10; // Space for footer

   // Add Today's Date and Time at the Bottom
   doc.setFontSize(8);
   doc.text(`Print Date & Time: ${currentDateTime}`, pageWidth - 200, footerY, { align: 'left' });

   // Add Page Number
   doc.text(`Page ${pageNumber}`, pageWidth - 20, footerY, { align: 'right' });

      doc.save('Attendance_Report.pdf'); // Save PDF
  });
};

const columns = [
  {
    accessorKey: 'id',
    header: 'SL',
    size: 50,
    Cell: ({ row }) => row.index + 1,
   },
  // { accessorKey: "id", header: "ID", size: 50 },
   { accessorKey: "empidr", header: "Emp Id", size: 50 },
  { accessorKey: "emp_name", header: "Employee Name", size: 50 },
  { accessorKey: "desig", header: "Designation", size: 50 },
  { accessorKey: "attdate", header: "Date", size: 50 },
  { accessorKey: "intime", header: "Log In Time", size: 50 },
  { accessorKey: "outtime", header: "Log Out Time", size: 50 ,},
  {accessorKey: "remarks",header: "Remarks", size: 50},

];

const handleDownloadPDF = () => {
  const doc = new jsPDF("portrait"); 
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const companyInfo = {
    name: "Capital Market Stabiliztion Fund",
    address:
      "Dhaka Chamber Building(3rd Floor), 65-66 Motijheel C/A, Dhaka-1000\nTel: +880241052430, Email: claim@cmsfbd.org",
  };

  const reportInfo = {
    title: "Employee Attendance Report",
    space:'',
    instrument: `Days: ${dayDifference} Leave: ${leaveCount} Holidays:${holidayCount} Weekend: ${weekendCount} Absent: ${absentCount}`,
    investorCode: `Attendance Records of CMSF Employee(s) as follows:`,
    dateRange: `Penalty: ${lateCount} Salary Deduct: ${salaryDeductCount} Salary Days: ${dayDifference-salaryDeductCount}`,
  };

  // Add company header
  doc.setFontSize(12);
  doc.text(companyInfo.name, 14, 13);
  doc.setFontSize(8);
  doc.text(companyInfo.address, 14, 19);
  doc.setFont("helvetica", "bold");

  // Add report title and other info
  doc.setFontSize(8);
  doc.text(reportInfo.title, pageWidth - 14, 15, { align: "right" });
  doc.text(reportInfo.space, 14, 32);
  doc.text(reportInfo.investorCode, 14, 32);
  doc.text(reportInfo.instrument, 14, 40);
  doc.text(reportInfo.dateRange, 14, 44);

  // Table columns
  const tableColumns = columns.map((column) => column.header);

  // Prepare table data for PDF
  const tableDataForPDF = tableData.map((row, index) => {
    return columns.map((column) => {
      if (column.accessorKey === "id") {
        return index + 1;
      }
      if (column.accessorKey === "transaction_date") {
        const rawDate = row[column.accessorKey];
        const date = new Date(rawDate);
        return date
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .replace(/ /g, "-"); // Format: '02-Jan-2022'
      }
      if (column.accessorKey === "netamt" || column.accessorKey === "cnetamt" ) {
        const rawValue = row[column.accessorKey];
        const value = Number(rawValue); // Ensure it's a number
        return isNaN(value) ? "0.00" : value.toFixed(2); // Format to 2 decimal places, handle invalid values
      }
      if (column.accessorKey === "nshare" || column.accessorKey === "cnshare"  ) {
        const rawValue = row[column.accessorKey];
        const value = Number(rawValue); // Ensure it's a number
        return isNaN(value) ? "0.00" : value.toFixed(0); // Format to 2 decimal places, handle invalid values
      }
      if (column.header === "Outstanding Cash") { // Replace with your column's header or condition
        const total = Number(row["netamt"]?? 0) ;
        const paid = Number(row["cnetamt"]?? 0) ;
        const result = total - paid;
        return result.toFixed(2); // Format to 2 decimal places
      }
      if (column.header === "Outstanding Stock") { // Replace with your column's header or condition
        const total = Number(row["nshare"]?? 0) ;
        const paid = Number(row["cnshare"]?? 0) ;
        const result = total - paid;
        return result.toFixed(0); // Format to 2 decimal places
      }
      return row[column.accessorKey];
    });
  });

 // Add "Total" row at the bottom
const totalRow = columns.map((column) => {
  if (column.accessorKey === "investors_dividend_type") return "Total"; 
  if (column.accessorKey === "netamt") return ""; 
  if (column.accessorKey === "cnetamt") return ""; 
  if (column.header === "Outstanding Cash") return ""; 
  if (column.accessorKey === "nshare") return ""; 
  if (column.accessorKey === "cnshare") return" "; 
  if (column.header === "Outstanding Stock") return ""; 

  return ""; 
});

  tableDataForPDF.push(totalRow); // Append the total row at the bottom
  // Get current date & time
  const currentDateTime = new Date()
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
    .replace(",", "");

  doc.autoTable({
    head: [tableColumns],
    body: tableDataForPDF,
    startY: 48,
    theme: "grid",
    styles: {
      fontSize: 7,
      cellPadding: 1.2,
      lineWidth: 0,
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: "#000000",
      halign: "center",
      lineWidth: 0.5,
    },
    bodyStyles: {
      textColor: "#000000",
      halign: "left",
    },
    columnStyles: {
      0: { halign: "left" },
    },
    tableWidth: "auto",

      // Bold "Total" and total quantity
    didParseCell: function (data) {
    const rowIndex = data.row.index;
    const lastRowIndex = tableDataForPDF.length - 1;

    if (rowIndex === lastRowIndex) {
      data.cell.styles.fontStyle = "bold"; // Make "Total" row bold
      data.cell.styles.fontSize = 9; // Increase text size
    }
  },
    didDrawCell: (data) => {
      if (data.section === "body") {
        const doc = data.doc;
        const { cell } = data;

        doc.setLineDash([1, 1], 0);
        doc.setDrawColor(130, 130, 130);

        doc.line(cell.x, cell.y, cell.x + cell.width, cell.y); // Top line
        doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height); // Bottom line
      }
    },
    didDrawPage: (data) => {
      // Add Date & Time on the bottom-left corner
      doc.setFont("helvetica", "italic");
      doc.setFontSize(8);
      doc.setTextColor(149, 149, 149);
      doc.text(`Print Date & Time: ${currentDateTime}`, 14, pageHeight - 10);

      // Add Page Number on the bottom-right corner
      const pageNumber = `Page ${data.pageNumber}`;
      doc.text(pageNumber, pageWidth - 14, pageHeight - 10, { align: "right" });
    },
  });
  doc.save("Employee_Attendance_Report.pdf");
};

  const handleDownloadExcel = () => {
  const worksheetData = tableData.map(item => [
    item.empidr,
    item.emp_name,
    item.desig,
    item.attdate,
    item.intime,
    item.outtime,
    item.remarks,
  ]);

  const sheetData = [];
  sheetData.push(['Employee Attendance Report']);

  if (reportType === 'All') {
    sheetData.push([`Date: ${singleDateforAllType}`]);
  } else {
    sheetData.push([`From: ${stateValus.fromDate} To: ${stateValus.toDate}`]);
  }

  if (dayDifference || leaveCount || holidayCount || weekendCount || absentCount) {
    sheetData.push([`Days: ${dayDifference || 0} Leave: ${leaveCount || 0} Holidays: ${holidayCount || 0} Weekend: ${weekendCount || 0} Absent: ${absentCount || 0}`,]);
  }

  if (lateCount || salaryDeductCount || dayDifference ) {
    sheetData.push([`Penalty: ${lateCount|| 0} Salary Deduct:${salaryDeductCount|| 0} Salary Days:${dayDifference-salaryDeductCount}`,]);
  }

  sheetData.push(['Emp Id','Employee Name','Designation', 'Date', 'Log In Time', 'Log Out Time', 'Remarks']);

  
  if (worksheetData.length > 0) {
    sheetData.push(...worksheetData); 
  } else {
    sheetData.push(['No Data Available']); 
  }

  const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Employee_Attendance');

  
  XLSX.writeFile(workbook, 'Employee_Attendance.xlsx');
};

  const contentRef = useRef();

  const generatePdf = () => {
    const pdf = new jsPDF('p', 'mm', 'a4'); // Create a new PDF document
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    html2canvas(pdfRef.current, {
      scale: 2,
      useCORS: true,
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const aspectRatio = imgHeight / imgWidth;
      const scaleFactor = pdfWidth / imgWidth;
      let remainingHeight = imgHeight;
      let position = 0;

      while (remainingHeight > 0) {
        const currentHeight = Math.min(remainingHeight, pdfHeight / scaleFactor);

        pdf.addImage(
          imgData,
          'PNG',
          0,
          position,
          pdfWidth,
          pdfWidth * aspectRatio * (currentHeight / imgHeight),
          undefined,
          'FAST'
        );

        remainingHeight -= currentHeight;
        position = -((imgHeight - remainingHeight) / scaleFactor);

        if (remainingHeight > 0) {
          pdf.addPage();
          position = 0;
        }
      }

      pdf.save('Employee_Attendance_Report.pdf');
    });
  };

  const generatePdf2 = async () => {
    const content = pdfRef.current;

    const pdf = new jsPDF('p', 'mm', 'a4');
    const canvas = await html2canvas(content);
    const imgData = canvas.toDataURL('image/png');

    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;

    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // pdf.save(`Attendance_Report_${stateValus.empId}.pdf`);
    pdf.save(`Attendance_Report_Report.pdf`);
  };

  var late = 0
  // let startDate = new Date(stateValus.fromDate.split('-').reverse().join('-'))
  // let endDate = new Date(stateValus.toDate.split('-').reverse().join('-'))
  let startDate = new Date(stateValus.fromDate)
  let endDate = new Date(stateValus.toDate)
 
   const timeDifference = endDate - startDate;
   const dayDifference = (timeDifference / (1000 * 3600 * 24))+1;
  // console.log( endDate +' <--> '+startDate )
  // console.log(dayDifference)

  const lateCount = data.filter((item) => item.remarks === 'Late').length;
  const holidayCount = data.filter((item) => item.remarks === 'holiday').length;
  const casualLeaveCount = data.filter((item) => item.remarks === 'Casual Leave').length;
  const sickLeaveCount = data.filter((item) => item.remarks === 'Sick Leave').length;
  const leaveCount = casualLeaveCount + sickLeaveCount;
  const weekendCount = data.filter((item) => item.remarks === 'weekend').length;
  const salaryDeductCount = data.filter((item) => item.remarks === 'Absent').length + Math.floor(lateCount/3);
  const absentCount = data.filter((item) => item.remarks === 'Absent').length;

  return (
    <>
      <ResponsiveContainer style={{ width: '80%', maxWidth: '80%', padding: '10px' }}>
          
        <Grid ref={pdfRef2} className={ReportStyle.form}> 

        </Grid>

        <Grid ref={pdfRef} className={ReportStyle.form}>

        <Grid className={ReportStyle.headerLogo}>
                  <div className={ReportStyle.CmsfLogo}>
                {/* <img className={ReportStyle.Golden50} src={Golden50} alt='CMSF Logo' /> */}
                  </div>
                  <div className={ReportStyle.CmsfLogo}>
                <img className={ReportStyle.CmsfLogo} src={CmsfLogo} alt='CMSF Logo' />
                  </div>
                  <div className={ReportStyle.Mujib100}>
                {/* <img className={ReportStyle.Mujib100} src={Mujib100} alt='CMSF Logo' /> */}
                  </div>

              </Grid>

        <Grid className={ReportStyle.address} style={{ textAlign: 'center', fontSize: '1rem', margin: '10px 0' }}>
            <span>Dhaka Chamber Building(3rd Floor), 65-66 Motijheel C/A, Dhaka-1000</span><br />
            <span>Tel: +880241052430, Email: claim@cmsfbd.org</span>
        </Grid>

          <h4 style={{ textAlign: 'center', fontSize: '2rem' }}><strong>Employee Attendance Report</strong></h4>
          {reportType!=='All' &&<h6 style={{ textAlign: 'center'}}><strong>From:</strong> {stateValus.fromDate} <strong>To:</strong> {stateValus.toDate}</h6>}
          {reportType==='All' &&<h6 style={{ textAlign: 'center'}}><strong>Date:</strong> {singleDateforAllType}</h6>}
          <br></br>
          {reportType==='Individual'?<h6 style={{ textAlign: 'center'}}><strong>Days:</strong> {dayDifference}<strong> <strong> Leave:</strong> {leaveCount} Holidays:</strong> {holidayCount}<strong> Weekend:</strong> {weekendCount} <strong> Absent:</strong> {absentCount} </h6>:''}
          {reportType==='Individual'?<h6 style={{ textAlign: 'center'}}>  <strong> Penalty:</strong> {lateCount} <strong>Salary Deduct:</strong> {salaryDeductCount}<strong> Salary Days:</strong> {dayDifference-salaryDeductCount}</h6>:''}
          <br></br>
          <Grid className={ReportStyle.GategoryName2} style={{ overflowX: 'auto' ,}}>
            <table style={{ width: '90%', borderCollapse: 'collapse'}}>
              <thead>
                <tr>
                  <th className={styles.td} colSpan={1}>Sl</th>
                    <th className={styles.td} colSpan={2}>Emp Id</th>
                  <th className={styles.td} colSpan={2}>Name</th>
                  <th className={styles.td} colSpan={2}>Designation</th>
                  <th className={styles.td} colSpan={1}>Date</th>
                  <th className={styles.td} colSpan={1}>Log In Time</th>
                  <th className={styles.td} colSpan={1}>Log Out Time</th>
                  <th className={styles.td} colSpan={1}>Remarks</th>
                  
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index} >
                    <td className={styles.td} colSpan={1}>{index + 1}</td>
                    <td className={styles.td} colSpan={2}>{item.empidr}</td>
                    <td className={styles.td} colSpan={2}>{item.emp_name}</td>
                    <td className={styles.td} colSpan={2}>{item.desig}</td>
                    <td className={styles.td} colSpan={1}>{item.attdate}</td>
                    {/* <td className={styles.td} colSpan={3}>{
                      (() => {
                        const date = new Date(item.punch_date);
                        return date.toLocaleDateString("en-GB");
                      })()}</td> */}

                    <td className={styles.td} colSpan={1}>{item.intime}</td>
                    {/* <td className={styles.td} colSpan={3}>{
                      (() => {
                        const date = new Date(item.check_in_time);
                        return date.toLocaleTimeString("en-GB");
                      })()}</td> */}

                    <td className={styles.td} colSpan={1}>{item.outtime}</td>
                    {/* <td className={styles.td} colSpan={3}>{
                      (() => {
                        const date = new Date(item.check_out_time);
                        return date.toLocaleTimeString("en-GB");
                      })()}</td> */}

                       {/* <td className={styles.td} style={{ backgroundColor: item.remarks === 'Late' ? '#FF7F7F' : item.remarks === 'weekend' ? 'yellow' : '' }}colSpan={3}>
                        {item.remarks}
                        </td> */}
                        <td className={styles.td} colSpan={1}>
                        {item.remarks}
                        </td>
                  </tr>
                ))}
                {/* <tr>
                  <td className={styles.td} colSpan={6} style={{ fontSize: '1.3rem', textAlign: 'center', fontWeight: 'bold' }}>Total</td>
                  <td className={styles.td} colSpan={3} style={{ fontSize: '1rem', fontWeight: 'bold' }}>{grandTotal.nst.toFixed(2)}</td>
                  <td className={styles.td} colSpan={3} style={{ fontSize: '1rem', fontWeight: 'bold' }}>{grandTotal.sett.toFixed(2)}</td>
                  <td className={styles.td} colSpan={3} style={{ fontSize: '1rem', fontWeight: 'bold' }}>{grandTotal.outs.toFixed(2)}</td>
                </tr> */}
              </tbody>
            </table>
          </Grid>

          {/* <Grid className={ReportStyle.msgDiv}>
            <span className={ReportStyle.msg}><i>This is a system-generated report.</i></span>
          </Grid> */}
        </Grid>

        <Button 
          style={{ margin: '10px', marginTop: '20px', backgroundColor: '#45CFDD' }}  
          variant="contained" 
          color="default" 
          onClick={handleDownloadPDF}>
          Download PDF
        </Button>

        <Button 
          style={{ margin: '10px', marginTop: '20px', backgroundColor: '#45CFDD' }}  
          variant="contained" 
          color="default" 
          onClick={handleDownloadExcel}>
          Download Excel
        </Button>

      </ResponsiveContainer>
    </>
  );
};

export default UiOfAttendanceReport;
